export default {
      id: "ic-han-mental-usage",
      viewBox: "0 0 26 26",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#ic-han-mental-usage",
      toString: function () {
        return this.url;
      }
    }